module.exports = __webpack_public_path__ + "img/casque.13611de9.svg";